import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadCampaign = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      title: "Iniciar/Pausar",
      align: "center",
      width: "50px",
      minWidth: "50px",
    },
    {
      title: "Campanhas",
      align: "left",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "Grupo de Leads",
      align: "left",
      width: "120px",
      minWidth: "120px",
    },
    {
      title: "Número disparo",
      align: "left",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "Processo(s)",
      align: "left",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "Próximo disparo",
      align: "center",
      width: "100px",
      minWidth: "100px",
    },
    {
      title: "Data de criação",
      align: "left",
      width: "80px",
      minWidth: "80px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
